import { render, staticRenderFns } from "./_listScraps.vue?vue&type=template&id=781e829a&scoped=true&"
import script from "./_listScraps.vue?vue&type=script&lang=js&"
export * from "./_listScraps.vue?vue&type=script&lang=js&"
import style0 from "./_listScraps.vue?vue&type=style&index=0&id=781e829a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781e829a",
  null
  
)

export default component.exports